import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import THead from './THead';
import TBody from './TBody';
import EmptyState from '../EmptyState';
import LoadingIndicator from '../LoadingIndicator';
import AlertMessage from '../AlertMessage';

import './styles.css';

const propTypes = {
  data: PropTypes.array,
  headers: PropTypes.array.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
};

const defaultProps = {
  data: [],
  onRowClick: () => {},
  size: 'small',
};


class Table extends Component {
  render() {
    const {
      headers,
      dataOrder,
      onOrderColumn,
      wrapCells = false,
      hasHover,
      renderRowRight,
      activeRow,
      isActive,
    } = this.props;

    return (
      <div className={this.props.className}>
        {
          this.props.error &&
          !this.props.isFetching &&
          <div className={`Table Table--${this.props.size || 'small'}`}>
            <AlertMessage
              actionText="Tentar novamente"
              message={this.props.error}
              onRetry={this.props.onRetry}
              className="Table__error-message"
              error
            />
          </div>
        }
        {
          this.props.isFetching &&
          <div className={`Table Table--${this.props.size || 'small'}`}>
            <LoadingIndicator
              theme="dark"
              text="Carregando"
              className="Table__loading-indicator"
            />
          </div>
        }
        {
            this.props.data.length > 0 &&
            !this.props.isFetching &&
            <table className={`Table Table--${this.props.size || 'small'}`}>
              <THead
                dataOrder={dataOrder}
                headers={headers}
                onOrderColumn={onOrderColumn}
              />

              <TBody
                onRowClick={this.props.onRowClick}
                rows={this.props.data}
                headers={headers}
                wrapCells={wrapCells}
                hasHover={hasHover}
                renderRowRight={renderRowRight}
                activeRow={activeRow}
                isActive={isActive}
              />
            </table>
        }
        {
            this.props.data.length === 0 &&
            !this.props.isFetching &&
            !this.props.error &&
            <EmptyState
              className="Table__empty-state"
              message="Não existem dados para exibição."
            />
        }
      </div>
    );
  }
}

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

export default Table;
